import {validateEmail} from '../../helpers/utils'

export default class Footer {
  constructor(component) {
    this.dom = {
      $component: component,
      $signUpWrap: component.querySelector('.js-footerSignUpWrap'),
      $successMessage: component.querySelector('.js-signUpSuccess'),
      $errorMessage: component.querySelector('.js-signUpError'),
      $form: component.querySelector('#js-footerSignupForm'),
      $email: component.querySelector('.js-signUpEmailInput')
    }
    this.state = {
      successClass: 'success',
      errorClass: 'error'
    }
    this.checkEmailHandler = this.checkEmail.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    this.attachKlaviyoForm()
    dom.$form.addEventListener('submit', this.checkEmailHandler)
  }

  attachKlaviyoForm() {
    KlaviyoSubscribe.attachToForms('#js-footerSignupForm', {
      success: this.submitSuccess.bind(this)
    })
  }

  submitSuccess(test) {
    const {dom, state} = this
    dom.$signUpWrap.classList.remove(state.errorClass)
    dom.$signUpWrap.classList.add(state.successClass)
  }

  checkEmail(e) {
    const {dom, state} = this
    const email = dom.$email.value

    if (!email) {
      return e.preventDefault()
    }

    if (!validateEmail(email)) {
      e.preventDefault()
      dom.$signUpWrap.classList.add(state.errorClass)
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.Footer = this
  }
}
